<template>
	<div class="mt-4">
		<h5>{{$t('about')}}</h5>
		<div class="app-panel container bg-white my-4 text-muted py-4">
			<img class="mb-4" src="@/resources/storelogo.png" />
			<h4>  {{$t('app.name')}} </h4>
			<div class="mb-2 small">{{$t('version.info')}} {{version}}</div>
			<div class="my-5 lead">
				{{$t('about.app')}}
			</div>	
			<h5>{{$t('privacy.h')}}</h5>
			<div class="text-left lead mb-4">
				<p>
				{{$t('privacy.statement')}}
				</p>
			</div>	
			<h5>{{$t('about.author.h')}}</h5>
			<div class="lead">
				{{$t('about.author')}}
			</div>	
			<div class="my-4 small">
				{{$t('about.credits')}}
			</div>	
			
			<div class="my-4 btn btn-primary" @click="goAhead()" > Alles klar, Go Ahead</div>
						
			</div>
	</div>
</template>

<script>
export default {
	computed:{
		version(){ return this.$store.getters.version }
	},
	methods:{
		goAhead(){ this.$store.dispatch('showDashboard') }
	}
	
}
</script>

<style scoped>
.with-header-offset{
	padding-top: 6rem;
}
</style>